export const enum PostVoucherErrors {
	ALREADY_USED = 'alreadyUsed',
	CUMULATIVE_LIMIT = 'cumulativeLimitExceeded',
	FAILED = 'failed',
	HOLDING_LIMIT = 'holdingLimitExceeded',
	LIMIT_EXCEEDED = 'limitExceeded',
	MINIMAL_LIMIT = 'minimalLimitExceeded'
}

export const PostVoucherErrorEnum = {
	// the transaction related to the Voucher redeeming failed, the Voucher is still available to be redeemed
	'00ad9646-643a-41db-b97a-970dec679f53': 'failed',
	//  the User is subject to regulatory restrictions
	'3d727162-d0b5-4ba0-a691-cdcbbc3bdcdf': 'failed',
	// the User's holding limit is exceeded
	'4569623f-852e-46a4-89d3-a4f860178ccc': 'holdingLimitExceeded',
	// the Voucher is not redeemable
	'508e8fdf-265e-459b-88d6-18e6dc534150': 'alreadyUsed',
	// the User's cumulative limits are exceeded
	'58c75c17-f7e7-4929-8c6a-bb093acd4594': 'cumulativeLimitExceeded',
	//  the transaction related to the Voucher redeeming failed, the Voucher redeeming may still be processed later once the issue is solved
	'8a3cf073-642d-4622-a067-8b188cd5ae0d': 'failed',
	// another User's limits are exceeded
	'a9aaebc8-0616-4019-b46a-687a56a87326': 'limitExceeded',
	// the User's minimal limits are exceeded
	'd4968b7d-3f7e-4c2c-ace6-d743f6d6b578': 'minimalLimitExceeded'
};
